import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useGetTaskListByProfileId = (profileId) => {
    const [taskList, setTaskList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTaskList = async () => {
        if (!profileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getTaskListByProfileId",
                profileId,
            });

            setTaskList(res.data.tasks || []);
        } catch (err) {
            setError(err);
            setTaskList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTaskList();
    }, [profileId]);

    return { taskList, loading, error, refetch: fetchTaskList };
};

export default useGetTaskListByProfileId;
